var map = {
	"./bash": 1659,
	"./java": 1660,
	"./json": 1661,
	"./julia": 1662,
	"./python": 1663,
	"./r": 1664,
	"./rust": 1665,
	"./scala": 1666,
	"./shell": 1667,
	"./sql": 1668,
	"./xml": 1669,
	"./yaml": 1670
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1658;